var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import { HAD_PATHS } from 'reports/had/constants/had.constant';
import { cwRoutePrefix, PerformancePath } from '../reports/cw/constants/cw.constant';
export var integrationLoginSuffix = '/login';
export var appLinkingLoginSuffix = '/redirect';
export var FOOTER_LEGAL_ENTITY = 'Elsevier Inc.';
export var EM_DASH = '—';
export var RoutePath = {
    login: "**".concat(integrationLoginSuffix),
    appLinkingLogin: "**".concat(appLinkingLoginSuffix),
    loginPath: '/login-service/login',
    userServicePath: '/apiv1/eolsUser/list',
    tokenServicePath: '/token-service',
    home: '/',
    cwIns: "".concat(cwRoutePrefix.instructor, "/home"),
    cwStu: "".concat(cwRoutePrefix.student, "/home"),
    had: '/hesiDashboard',
    ehr: '/eaqHesiReadiness',
    student: {
        home: '/student'
    },
    reportingPortal: '/reportingPortal',
    footerAccessibility: '/footer-accessibility'
};
export var PageNamePrefixes = {
    cw: 'Elsevier Performance Reports',
    ehr: 'EAQ HESI Readiness Dashboard',
    had: 'HESI Dashboard',
    sh: 'Shadow Health Dashboard',
    erp: 'Elsevier Reporting Portal',
    ps: 'Program Success Dashboard',
    hesi: 'HESI',
    dp: 'Dean Reporting Dashboard'
};
export var AppConstant = {
    PERSIST_KEY: 'globalPerformanceReportState',
    reduxResources: {
        ROUTER: 'router',
        APP_STATE: 'appState',
        LANGUAGE_STATE: 'languageState',
        FILTER_STATE: 'filterState',
        CW_STATE: 'cwState',
        COURSES_STATE: 'coursesState',
        HAD_STATE: 'hadState',
        EHR_STATE: 'ehrState',
        SH_STATE: 'shState',
        PS_STATE: 'psState',
        HESI_NG_STATE: 'hesiNGState',
        DP_STATE: 'dpState',
        TOAST_STATE: 'toastState'
    }
};
export var FeatureFlagNames = {
    APP_LINK_ASSIGNMENT_MANAGEMENT_ENABLE: 'APP_LINK_ASSIGNMENT_MANAGEMENT_ENABLE',
    CW_ACTIVE_COURSE_ENABLED: 'CW_ACTIVE_COURSE_ENABLED',
    CW_ASSIGNMENT_DETAIL_APP_LINK_ENABLED: 'CW_ASSIGNMENT_DETAIL_APP_LINK_ENABLED',
    CW_ASSIGNMENT_DETAIL_LINK_TO_EAB_ENABLED: 'CW_ASSIGNMENT_DETAIL_LINK_TO_EAB_ENABLED',
    CW_ASSIGNMENT_DETAIL_LINK_TO_OSMOSIS_ENABLED: 'CW_ASSIGNMENT_DETAIL_LINK_TO_OSMOSIS_ENABLED',
    CW_CLARITY_DATA_ICON_ENABLED: 'CW_CLARITY_DATA_ICON_ENABLED',
    CW_DATA_MASKING_ENABLED: 'CW_DATA_MASKING_ENABLED',
    CW_GRADE_WEIGHTING_SCORE_ENABLED: 'CW_GRADE_WEIGHTING_SCORE_ENABLED',
    CW_GRADE_WEIGHTING_SCORE_ENABLED_IN_GRADEBOOK: 'CW_GRADE_WEIGHTING_SCORE_ENABLED_IN_GRADEBOOK',
    CW_HAD_PRD_LINK_ENABLED: 'CW_HAD_PRD_LINK_ENABLED',
    CW_HIDE_GRADE_BOOK_FILTER_DROP_DOWN: 'CW_HIDE_GRADE_BOOK_FILTER_DROP_DOWN',
    CW_HIDE_STUDENT_DETAIL_CHART: 'CW_HIDE_STUDENT_DETAIL_CHART',
    CW_PERFORMANCE_COMPARED_TO_CLASS_AVERAGE_HIDDEN: 'CW_PERFORMANCE_COMPARED_TO_CLASS_AVERAGE_HIDDEN',
    CW_STUDENT_DETAIL_SELF_STUDY_QUESTIONS_CARD_ENABLED: 'CW_STUDENT_DETAIL_SELF_STUDY_QUESTIONS_CARD_ENABLED',
    CW_STUDENT_HOME_EAQ_TOPIC_REPORT_LINK_ENABLED: 'CW_STUDENT_HOME_EAQ_TOPIC_REPORT_LINK_ENABLED',
    CW_STUDENT_HOME_SELF_STUDY_QUESTIONS_CARD_ENABLED: 'CW_STUDENT_HOME_SELF_STUDY_QUESTIONS_CARD_ENABLED',
    CW_STUDENT_HOME_TOPIC_IN_NOVICE_OR_BELOW_ENABLED: 'CW_STUDENT_HOME_TOPIC_IN_NOVICE_OR_BELOW_ENABLED',
    CW_UPDATED_UI_ENABLED: 'CW_UPDATED_UI_ENABLED',
    CW_SHERPATH_ADS_ENABLED: 'CW_SHERPATH_ADS_ENABLED',
    ENABLE_EAQ_PERFORMANCE_APP_REDIRECT: 'ENABLE_EAQ_PERFORMANCE_APP_REDIRECT',
    DWH_STUDENT_DETAIL_BY_PROGRAM_API_ENABLED: 'DWH_STUDENT_DETAIL_BY_PROGRAM_API_ENABLED',
    DWH_STUDENT_EXAM_CATEGORY_API_ENABLED: 'DWH_STUDENT_EXAM_CATEGORY_API_ENABLED',
    DWH_STUDENT_EXAM_CATEGORY_BY_PROGRAM_API_ENABLED: 'DWH_STUDENT_EXAM_CATEGORY_BY_PROGRAM_API_ENABLED',
    DWH_STUDENT_SUMMARY_AND_STUDENT_EXAMS_API_ENABLED: 'DWH_STUDENT_SUMMARY_AND_STUDENT_EXAMS_API_ENABLED',
    ENABLE_STUDENT_CAN_CREATE_ASSIGNMENT: 'ENABLE_STUDENT_CAN_CREATE_ASSIGNMENT',
    ENABLE_STUDENT_STUDY_REDIRECT: 'ENABLE_STUDENT_STUDY_REDIRECT',
    EHR_CREATE_QUIZ_BUTTON_ENABLED: 'EHR_CREATE_QUIZ_BUTTON_ENABLED',
    EHR_STUDENT_DETAIL_PAGE_ENABLED: 'EHR_STUDENT_DETAIL_PAGE_ENABLED',
    EHR_STUDENT_TAB_ENABLED: 'EHR_STUDENT_TAB_ENABLED',
    EHR_SUB_NAV_ENABLED: 'EHR_SUB_NAV_ENABLED',
    EVOLVE_ID_ON_ANALYTICS_ENABLED: 'EVOLVE_ID_ON_ANALYTICS_ENABLED',
    HAD_CATEGORY_GROUP_DWH_ENABLE: 'HAD_CATEGORY_GROUP_DWH_ENABLE',
    HAD_CATEGORY_STATE_BASED_EXAM_ENABLED: 'HAD_CATEGORY_STATE_BASED_EXAM_ENABLED',
    HAD_CATEGORY_SUMMARY_DWH_ENABLED: 'HAD_CATEGORY_SUMMARY_DWH_ENABLED',
    HAD_COHORT_CATEGORY_DWH_ENABLED: 'HAD_COHORT_CATEGORY_DWH_ENABLED',
    HAD_COHORT_CATEGORY_TAB_ENABLED: 'HAD_COHORT_CATEGORY_TAB_ENABLED',
    HAD_COHORT_DETAIL_DWH_ENABLED: 'HAD_COHORT_DETAIL_DWH_ENABLED',
    HAD_COHORT_TRENDLINE_DWH_ENABLED: 'HAD_COHORT_TRENDLINE_DWH_ENABLED',
    HAD_CW_NEW_HEADER_ENABLE: 'HAD_CW_NEW_HEADER_ENABLE',
    HAD_EXAM_CATEGORY_DWH_ENABLED: 'HAD_EXAM_CATEGORY_DWH_ENABLED',
    HAD_EXAM_DETAIL_PAGE_ENABLED: 'HAD_EXAM_DETAIL_PAGE_ENABLED',
    HAD_NGN_ENABLE_COHORTCARDNGN: 'HAD_NGN_ENABLE_COHORTCARDNGN',
    HAD_NGN_ENABLE_COHORTLEVELNGN: 'HAD_NGN_ENABLE_COHORTLEVELNGN',
    HAD_NGN_ENABLE_EXAMLEVELNGN: 'HAD_NGN_ENABLE_EXAMLEVELNGN',
    HAD_NGN_ENABLE_NEW_SCORING: 'HAD_NGN_ENABLE_NEW_SCORING',
    HAD_NGN_ENABLE_STUDENTLEVELNGN: 'HAD_NGN_ENABLE_STUDENTLEVELNGN',
    HAD_NGN_LINK_OUT_ENABLED: 'HAD_NGN_LINK_OUT_ENABLED',
    HAD_PN_PROGRAM_HIDDEN: 'HAD_PN_PROGRAM_HIDDEN',
    HAD_STUDENT_DETAIL_LINK_CROSS_APP_ENABLED: 'HAD_STUDENT_DETAIL_LINK_CROSS_APP_ENABLED',
    HAD_STUDENT_DETAIL_MULTIPLE_COHORT_ENABLED: 'HAD_STUDENT_DETAIL_MULTIPLE_COHORT_ENABLED',
    HAD_STUDENT_DETAIL_PAGE_ENABLED: 'HAD_STUDENT_DETAIL_PAGE_ENABLED',
    HAD_STUDENT_SUMMARY_NEW_TABLE: 'HAD_STUDENT_SUMMARY_NEW_TABLE',
    HAD_STUDENT_TRENDLINE_BY_PROGRAM_DWH_ENABLED: 'HAD_STUDENT_TRENDLINE_BY_PROGRAM_DWH_ENABLED',
    HAD_STUDENT_TRENDLINE_DWH_ENABLED: 'HAD_STUDENT_TRENDLINE_DWH_ENABLED',
    HAD_STUDENT_VIEW_MULTI_PROGRAM: 'HAD_STUDENT_VIEW_MULTI_PROGRAM',
    HESI_EXAMRESULTS_CATEGORY_DRILLDOWN: 'HESI_EXAMRESULTS_CATEGORY_DRILLDOWN',
    HESI_EXAMRESULTS_LEGAL_DISCLAIMER: 'HESI_EXAMRESULTS_LEGAL_DISCLAIMER',
    HESI_EXAMRESULTS_MULTIPLEATTEMPTSINDICATOR: 'HESI_EXAMRESULTS_MULTIPLEATTEMPTSINDICATOR',
    HESI_NEEDSFURTHERPREPARATION_LABELUPDATE: 'HESI_NEEDSFURTHERPREPARATION_LABELUPDATE',
    HESI_NG_HIDE_ITEM_DETAILS_TABLE: 'HESI_NG_HIDE_ITEM_DETAILS_TABLE',
    HESI_A2_EXAM_RESULTS_ENABLED: 'HESI_A2_EXAM_RESULTS_ENABLED',
    NGN_SUMMARY_API_ENABLED: 'NGN_SUMMARY_API_ENABLED',
    PRD_COURSE_AGGREGATE: 'PRD_COURSE_AGGREGATE',
    PRD_CLARITY_DATA_ICON_ENABLED: 'PRD_CLARITY_DATA_ICON_ENABLED',
    PRD_ENABLE_ASSIGNMENT_DETAIL: 'PRD_ENABLE_ASSIGNMENT_DETAIL',
    PRD_ENABLE_CARE_PLAN: 'PRD_ENABLE_CARE_PLAN',
    PRD_ENABLE_CJMM_ASSIGNMENT_DETAIL: 'PRD_ENABLE_CJMM_ASSIGNMENT_DETAIL',
    PRD_ENABLE_CJMM_COURSE_LEVEL: 'PRD_ENABLE_CJMM_COURSE_LEVEL',
    PRD_ENABLE_CJMM_STUDENT_DETAIL: 'PRD_ENABLE_CJMM_STUDENT_DETAIL',
    PRD_ENABLE_EDUCATION_EMPATHY: 'PRD_ENABLE_EDUCATION_EMPATHY',
    PRD_ENABLE_STUDENT_DETAIL_ASSIGNMENT_LINKS: 'PRD_ENABLE_STUDENT_DETAIL_ASSIGNMENT_LINKS',
    PRD_ENABLE_STUDENT_PROFILE: 'PRD_ENABLE_STUDENT_PROFILE',
    PRD_ENABLE_STUDENT_PROFILE_LINKING: 'PRD_ENABLE_STUDENT_PROFILE_LINKING',
    PRD_HIDE_INSTRUCTOR_DROPDOWN: 'PRD_HIDE_INSTRUCTOR_DROPDOWN',
    PRD_PRODUCT_DEMO_INSTRUCTOR_ID: 'PRD_PRODUCT_DEMO_INSTRUCTOR_ID',
    PS_ASSOCIATE_DETAILS_ENABLED: 'PS_ASSOCIATE_DETAILS_ENABLED',
    PS_CLARITY_DATA_ICON_ENABLED: 'PS_CLARITY_DATA_ICON_ENABLED',
    PS_EAQ_TOPIC_MASTERY_ADDITIONAL_RESOURCES_ENABLED: 'PS_EAQ_TOPIC_MASTERY_ADDITIONAL_RESOURCES_ENABLED',
    PS_NGN_ENABLE_NEW_SCORING: 'PS_NGN_ENABLE_NEW_SCORING',
    PS_TAP_SH_CATEGORY_ENABLED: 'PS_TAP_SH_CATEGORY_ENABLED',
    PS_STUDENT_NOTES_ENABLED: 'PS_STUDENT_NOTES_ENABLED',
    TSP_GATEWAY_LINK_FEATURE_ENABLED: 'TSP_GATEWAY_LINK_FEATURE_ENABLED',
    PERFROMANCE_DEMO_APP_ENABLED: 'PERFORMANCE_DEMOAPP_ENABLED',
    ENABLE_MOCK_SERVICE_WORKER: 'ENABLE_MOCK_SERVICE_WORKER',
    GRADEBOOK_BENCHMARK_ENABLED: 'GRADEBOOK_BENCHMARK_ENABLED',
    PRD_CATEGORY_TAB_ENABLED: 'PRD_CATEGORY_TAB_ENABLED',
    HESI_BENCHMARK_ENABLED: 'HESI_BENCHMARK_ENABLED',
    SHERPATH_CLASSIC_LINK_ENABLED: 'SHERPATH_CLASSIC_LINK_ENABLED',
    EAB_GRADEPOINTS_ENABLED: 'EAB_GRADEPOINTS_ENABLED',
    LIST_CUSTOMER_ALLOW_ACCESS_A2: 'LIST_CUSTOMER_ALLOW_ACCESS_A2',
    ENABLE_AMA_ASSIGNMENT_DETAIL: 'ENABLE_AMA_ASSIGNMENT_DETAIL',
    HAD_CATEGORY_HESI_DROPDOWN: 'HAD_CATEGORY_HESI_DROPDOWN',
    HESI_CATEGORY_DROPDOWN: 'HESI_CATEGORY_DROPDOWN',
    DEAN_DASHBOARD_THRESHOLDS_ENABLED: 'DEAN_DASHBOARD_THRESHOLDS_ENABLED',
    PSD_DEAN_HESI_THRESHOLDS_ENABLED: 'PSD_DEAN_HESI_THRESHOLDS_ENABLED',
    PSD_DEAN_ECRID: 'PSD_DEAN_ECRID',
    PSD_DEAN_DEMO_ECRID: 'PSD_DEAN_DEMO_ECRID',
    HRND_SUBSCRIPTION_ENABLE: 'HRND_SUBSCRIPTION_ENABLE',
    HRND_CUSTOMIZATION: 'HRND_CUSTOMIZATION',
    USPD_EAQ_TOPIC_REPORT_ENABLED: 'USPD_EAQ_TOPIC_REPORT_ENABLED',
    PSD_DEAN_FILTER_ENABLED: 'PSD_DEAN_FILTER_ENABLED',
    USPD_HESI_SAFE_MED_ENABLED: 'USPD_HESI_SAFE_MED_ENABLED',
    USPD_WGU_EXPERIENCE_ENABLED: 'USPD_WGU_EXPERIENCE_ENABLED',
    PSD_DEAN_SHERPATH_ENABLED: 'PSD_DEAN_SHERPATH_ENABLED',
    PSD_DEAN_HIDING_METRICS_ENABLED: 'PSD_DEAN_HIDING_METRICS_ENABLED',
    PSD_DEAN_SAI_ENABLED: 'PSD_DEAN_SAI_ENABLED',
    PSD_DEAN_ELSEVIER_ANALYST_ENABLED: 'PSD_DEAN_ELSEVIER_ANALYST_ENABLED',
    USPD_SPARK_ENABLED: 'USPD_SPARK_ENABLED'
};
export var FeatureFlagGroupNames = {
    HAD_PN_PROGRAM_HIDDEN_GROUP: 'HAD_PN_PROGRAM_HIDDEN_GROUP'
};
export var CW_ENGAGEMENT_CARD_ID = {
    classAverageScore: 'CW_CLASS_AVERAGE_SCORE',
    assignmentCompleted: 'CW_ASSIGNMENT_COMPLETED',
    numberOfStudentsWithPastDue: 'CW_NUMBER_OF_STUDENTS_WITH_PAST_DUE',
    assignmentsBelowCompletionThreshold: 'CW_ASSIGNMENTS_BELOW_COMPLETION_THRESHOLD',
    pastDueAssignments: 'CW_PAST_DUE_ASSIGNMENTS',
    disengagedStudents: 'CW_DISENGAGED_STUDENTS'
};
export var CW_INSTRUCTOR_HOME_CARD_ID = {
    assignmentCompleted: 'CW_INSTRUCTOR_HOME_COMPLETED_ASSIGNMENTS',
    aboveClassAvg: 'CW_INSTRUCTOR_HOME_ABOVE_CLASS_AVG',
    disengagedStudents: 'CW_DISENGAGED_STUDENTS'
};
export var ANALYTIC_FEATURES = (_a = {
        CW_INSTRUCTOR_HOME_VIEW_MY_COURSE_PLAN_CLICK: 'cw-instructor-home__view_my_course_plan--click',
        CW_INSTRUCTOR_HOME_VIEW_ALL_COURSES_CLICK: 'cw-instructor-home__view_all_courses--click',
        CW_INSTRUCTOR_HOME_TAKE_A_TOUR_CLICK: 'cw-instructor-home__take-a-tour--click',
        CW_ENGAGEMENT_STUDENT_TAB_VIEW: 'cw-engagement__student-tab--view',
        CW_ENGAGEMENT_ASSIGNMENT_TAB_VIEW: 'cw-engagement__assignment-tab--view',
        CW_ASSIGNMENT_SUMMARY_GRADED_ASSIGNMENTS_ONLY_ENABLE: 'cw_assignment_summary-graded-assignments-only--enable',
        CW_ASSIGNMENT_SUMMARY_GRADED_ASSIGNMENTS_ONLY_DISABLE: 'cw_assignment_summary-graded-assignments-only--disable',
        CW_STUDENT_HOME_ASSIGNMENT_SUMMARY_TAB_VIEW: 'cw-student-home__assignment-summary-tab--view',
        CW_STUDENT_HOME_ASSIGNMENT_SUMMARY_GRADED_ASSIGNMENTS_ONLY_ENABLE: 'cw-student-home__assignment-summary-graded-assignments-only--enable',
        CW_STUDENT_HOME_ASSIGNMENT_SUMMARY_GRADED_ASSIGNMENTS_ONLY_DISABLE: 'cw-student-home__assignment-summary-graded-assignments-only--disable',
        CW_STUDENT_HOME_ASSIGNMENT_ENGAGEMENT_TAB_VIEW: 'cw-student-home__assignment-engagement-tab--view',
        CW_STUDENT_HOME_ASSESSMENT_SUMMARY_TAB_VIEW: 'cw-student-home__assessment-summary-tab--view',
        CW_STUDENT_HOME_ASSIGNMENT_ENGAGEMENT_GRADED_ASSIGNMENTS_ONLY_ENABLE: 'cw-student-home__assignment-engagement-graded-assignments-only--enable',
        CW_STUDENT_HOME_ASSIGNMENT_ENGAGEMENT_GRADED_ASSIGNMENTS_ONLY_DISABLE: 'cw-student-home__assignment-engagement-graded-assignments-only--disable',
        CW_STUDENT_HOME_EAQ_TOPIC_REPORT_CLICK: 'cw-student-home__eaq-topic-report--click',
        CW_STUDENT_HOME_CREATE_QUIZ_BUTTON_CLICK: 'cw-student-home__create-quiz-button--click',
        CW_COURSE_AGGREGATE_COURSE_SEARCH: 'cw-course-aggregate__search',
        CW_COURSE_AGGREGATE_COURSE_SORT_BY_CLICK: 'cw-course-aggregate__sort-by--click',
        CW_COURSE_AGGREGATE_ACTIVE_COURSE_ONLY_ENABLE: 'cw-course-aggregate__active_course_only--enable',
        CW_COURSE_AGGREGATE_ACTIVE_COURSE_ONLY_DISABLE: 'cw-course-aggregate__active_course_only--disable',
        CW_GRADEBOOK_EXPORT_BUTTON_CLICK: 'cw-gradebook__export-button--click',
        CW_GRADEBOOK_ATTEMPT_TYPE_SELECT: 'cw-gradebook__attempt-type--select',
        CW_STUDENT_DETAIL_ASSIGNMENT_SUMMARY_TAB_VIEW: 'cw-student-detail__assignment-summary-tab--view',
        CW_STUDENT_DETAIL_ASSIGNMENT_SUMMARY_GRADED_ASSIGNMENTS_ONLY_ENABLE: 'cw-student-detail__assignment-summary-graded-assignments-only--enable',
        CW_STUDENT_DETAIL_ASSIGNMENT_SUMMARY_GRADED_ASSIGNMENTS_ONLY_DISABLE: 'cw-student-detail__assignment-summary-graded-assignments-only--disable',
        CW_STUDENT_DETAIL_ASSIGNMENT_ENGAGEMENT_TAB_VIEW: 'cw-student-detail__assignment-engagement-tab--view',
        CW_STUDENT_DETAIL_ASSIGNMENT_ENGAGEMENT_GRADED_ASSIGNMENTS_ONLY_ENABLE: 'cw-student-detail__assignment-engagement-graded-assignments-only--enable',
        CW_STUDENT_DETAIL_ASSIGNMENT_ENGAGEMENT_GRADED_ASSIGNMENTS_ONLY_DISABLE: 'cw-student-detail__assignment-engagement-graded-assignments-only--disable',
        CW_STUDENT_DETAIL_ASSIGNMENT_ABOVE_AVG_CLICK: 'cw-student-detail__assignment-above-avg--click',
        CW_STUDENT_DETAIL_EAQ_TOPIC_REPORT_CLICK: 'cw-student-detail__eaq-topic-report--click',
        CW_STUDENT_DETAIL_LINK_HAD_STUDENT_DETAIL_CLICK: 'cw-student-detail__link-had-student-detail--click',
        CW_STUDENT_DETAIL_EAQ_TOPIC_STUDENT_DETAIL_TAB_CLICK: 'cw-student-detail__eaq-topic-student-detail-tab--click',
        CW_STUDENT_DETAIL_EAQ_TOPIC_STUDENT_DETAIL_QUESTION_SET_FILTER_CLICK: 'cw-student-detail__eaq-topic-student-detail-question-set-filter--click',
        CW_STUDENT_DETAIL_EAQ_TOPIC_STUDENT_DETAIL_FILTER_CLICK: 'cw-student-detail__eaq-topic-student-detail-filter--click'
    },
    _a[CW_ENGAGEMENT_CARD_ID.classAverageScore] = 'cw-engagement__class-average-score--click',
    _a[CW_ENGAGEMENT_CARD_ID.assignmentCompleted] = 'cw-engagement__assignment-completed--click',
    _a[CW_ENGAGEMENT_CARD_ID.numberOfStudentsWithPastDue] = 'cw-engagement__past-due-students--click',
    _a[CW_ENGAGEMENT_CARD_ID.assignmentsBelowCompletionThreshold] = 'cw-engagement__assignments-below-completion-threshold--click',
    _a[CW_ENGAGEMENT_CARD_ID.pastDueAssignments] = 'cw-engagement__past-due-assignments--click',
    _a[CW_ENGAGEMENT_CARD_ID.disengagedStudents] = 'cw-engagement__disengaged-students--click',
    _a.CW_STUDENT_HOME_EAQ_TOPIC_REPORT_VIEW = 'cw-student-home__eaq-topic-report--view',
    _a.CW_EAQ_TOPIC_STUDENT_PERFORMANCE_CLICK = 'cw_eaq_topic_studentperformance--click',
    _a.CW_EAQ_TOPIC_TOPIC_TOGGLE_CLICK = 'cw_eaq_topic_topictoggle--click',
    _a.CW_EAQ_TOPIC_REPORT_ADD_ADAPTIVE_QUIZ_CLICK = 'cw-eaq-topic-report__add-adaptive-quiz-button--click',
    _a.CW_EAQ_TOPIC_PERFORMANCE_CATEGORY_CLICK = 'cw_eaq_topic_topictab_category--click',
    _a.CW_EAQ_TOPIC_PERFORMANCE_QUESTIONSET_CLICK = 'cw_eaq_topic_topictab_questionset--click',
    _a.CW_EAQ_TOPIC_QUESTIONSET_FILTER_CLICK = 'cw_eaq_topic_questionsetfilter--click',
    _a.CW_EAQ_TOPIC_CATEGORY_FILTER_CLICK = 'cw_eaq_topic_categoryfilter--click',
    _a.CW_EAQ_TOPIC_STUDENT_SEARCH_CLICK = 'cw_eaq_topic_studentsearch--click',
    _a.CW_EAQ_TOPIC_RESET_MASTERY_CLICK = 'cw_eaq_topic_resetmastery--click',
    _a.CW_COURSE_SUMMARY_PERFORMANCE_TAB_STUDENT_SEARCH = 'cw-course-summary__performance-tab-student--search',
    _a.CW_COURSE_SUMMARY_STUDENT_DETAILS_STUDENT_SEARCH = 'cw-course-summary__student-details-student--search',
    _a.CW_INSTRUCTOR_HOME_SEARCH_STUDENT_ON_STUDENT_NAME_CLICK = 'cw-instructor-home__search-student-on-student-name--click',
    _a.CW_COURSE_SUMMARY_GRADEBOOK_TAB_STUDENT_SEARCH = 'cw-course-summary__gradebook-tab-student--search',
    _a.CW_COURSE_SUMMARY_ENGAGEMENT_ASSIGNMENT_DETAILS_ASSIGNMENT_TAB_ASSIGNMENT_SEARCH = 'cw-course-summary__engagement-assignment-details-assignment-tab-assignment--search',
    _a.CW_COURSE_SUMMARY_ENGAGEMENT_ASSIGNMENT_DETAILS_STUDENT_TAB_STUDENT_SEARCH = 'cw-course-summary__engagement-assignment-details-student-tab-student--search',
    _a.CW_COURSE_SUMMARY_ASSIGNMENT_SUMMARY_TAB_ASSIGNMENT_SEARCH = 'cw-course-summary__assignment-summary-tab-assignment--search',
    _a.EHR_BY_TOPIC_AND_CHAPTER_VIEW = 'ehr__topic-and-chapter-tab--view',
    _a.EHR_BY_STUDENT_VIEW = 'ehr__student-tab--view',
    _a.EHR_SUBMISSIONS_STUDENTS_CLICK = 'ehr__zero-submissions-students--click',
    _a.EHR_BELOW_NOVICE_STUDENTS_CLICK = 'ehr__below-novice-students--click',
    _a.EHR_SPECIALTY_EXAM_READINESS_TAB_CREATE_A_QUIZ_BUTTON_CLICK = 'ehr__specialty-exam-readiness-tab-create-a-quiz-button--click',
    _a.EHR_SPECIALTY_EXAM_READINESS_BY_TOPIC_AND_CHAPTER_TAB_CLICK = 'ehr__specialty-exam-readiness-by-topic-and-chapter-tab--click',
    _a.EHR_SPECIALTY_EXAM_READINESS_BY_STUDENT_TAB_CLICK = 'ehr__specialty-exam-readiness-by-student-tab--click',
    _a.EHR_SPECIALTY_EXAM_READINESS_BY_STUDENT_TAB_TOPIC_FILTER_CLICK = 'ehr__specialty-exam-readiness-by-student-tab-topic-filter--click',
    _a.HAD_COHORT_DETAIL_BY_EXAM_VIEW = 'had-cohort-detail__exam-tab--view',
    _a.HAD_COHORT_DETAIL_BY_STUDENT_VIEW = 'had-cohort-detail__student-tab--view',
    _a.HAD_COHORT_DETAIL_AT_RISK_CLICK = 'had-cohort-detail__at-risk--click',
    _a.HAD_COHORT_DETAIL_BELOW_ACCEPTABLE_CLICK = 'had-cohort-detail__below-acceptable--click',
    _a.HAD_COHORT_DETAIL_ACCEPTABLE_CLICK = 'had-cohort-detail__acceptable--click',
    _a.HAD_COHORT_DETAIL_RECOMMENDED_CLICK = 'had-cohort-detail__recommended--click',
    _a.HAD_COHORT_DETAIL__STUDENT_EXIT_TAB_EXCLUDE_INACTIVE_STUDENTS_ENABLE = 'had-cohort-detail__student-exit-tab-exclude-inactive-students--enable',
    _a.HAD_COHORT_DETAIL__STUDENT_EXIT_TAB_EXCLUDE_INACTIVE_STUDENTS_DISABLE = 'had-cohort-detail__student-exit-tab-exclude-inactive-students--disable',
    _a.HAD_COHORT_DETAIL__STUDENT_EXIT_TAB_STUDENT_SEARCH = 'had-cohort-detail__student-exit-tab-student--search',
    _a.HAD_COHORT_DETAIL_BY_CATEGORY_VIEW = 'had-cohort-detail__category-tab--view',
    _a.HAD_COHORT_DETAIL_CATEGORY_CARD_CLICK = 'had-cohort-detail__category-card--click',
    _a.HAD_STUDENT_DETAIL_BY_CATEGORY_VIEW = 'had-student-detail__category-tab--view',
    _a.HAD_STUDENT_DETAIL_BY_EXAM_VIEW = 'had-student-detail__exam-tab--view',
    _a.HAD_STUDENT_DETAIL_BY_MONTH_VIEW = 'had-student-detail__month-tab--view',
    _a.HAD_STUDENT_DETAIL_BY_NGN_VIEW = 'had-student-detail__ngn-tab--view',
    _a.HAD_STUDENT_DETAIL_LINK_CW_STUDENT_DETAIL_CLICK = 'had-student-detail__link-cw-student-detail--click',
    _a.HAD_STUDENT_DETAIL_ADD_NOTES_BUTTON_CLICK = 'had-student-detail__add-notes-button--click',
    _a.HAD_STUDENT_HOME_BY_EXAM_VIEW = 'had-student-home__exam-tab--view',
    _a.HAD_STUDENT_HOME_BY_CATEGORY_VIEW = 'had-student-home__category-tab--view',
    _a.HAD_STUDENT_HOME_BY_MONTH_VIEW = 'had-student-home__month-tab--view',
    _a.HAD_STUDENT_HOME_BY_NGN_VIEW = 'had-student-home__ngn-tab--view',
    _a.HAD_STUDENT_DETAILS_VIEW_AS_STUDENT_BUTTON_CLICK = 'had-student-details__view-as-student-button--click',
    _a.HAD_STUDENT_DETAILS_SHOW_MULTIPLE_COHORTS_ENABLE = 'had-student-details__show-multiple-cohorts--enable',
    _a.HAD_STUDENT_DETAILS_SHOW_MULTIPLE_COHORTS_DISABLE = 'had-student-details__show-multiple-cohorts--disable',
    _a.HAD_COHORT_DETAIL_BY_MONTH_VIEW = 'had-cohort-detail__month-tab--view',
    _a.HAD_EXAM_DETAIL__VIEW_STUDENT_RESULTS_NGN_CLICK = 'had-exam-detail__view-students-results-on-items-for-NGN--click',
    _a.HAD_SELECT_NGN_COURSE_DIALOG__BACK_TO_EXAMS_RESULT_CLICK = 'had-select-ngn-course-dialog__back-to-exams-results--click',
    _a.HAD_SELECT_NGN_COURSE_DIALOG__VIEW_STUDENT_RESULT_ON_NGN_ITEM_CLICK = 'had-select-ngn-course-dialog__view-student-results-on-ngn-item--click',
    _a.HAD_EXAM_DETAILS__STUDENT_RESULTS_TAB_VIEW = 'had-exam-details__student-results-tab--view',
    _a.HAD_EXAM_DETAILS__CATEGORY_PERFORMANCE_TAB_VIEW = 'had-exam-details__category-performance-tab--view',
    _a.PRD_DASHBOARD_STUDENT_PERFORMANCE_VIEW = 'prd-dashboard__student-performance--view',
    _a.PRD_DASHBOARD_STUDENT_ENGAGEMENT_TAB_VIEW = 'prd-dashboard__student-engagement-tab--view',
    _a.PRD_DASHBOARD_ASSIGNMENT_SUMMARY_VIEW = 'prd-dashboard__assignment-summary--view',
    _a.PRD_DASHBOARD_CATEGORY_STRENGTHS_AND_WEAKNESSES_VIEW = 'prd-dashboard__category-strengths-and-weaknesses--view',
    _a.PRD_DASHBOARD_LOW_PERFORMING_STUDENT_CLICK = 'prd-dashboard__low-performing-student--click',
    _a.PRD_DASHBOARD_LOW_PATIENT_INTERACTION_TIME_CLICK = 'prd-dashboard__low-patient-interaction-time--click',
    _a.PRD_DASHBOARD_SUBJECTIVE_DATA_COLLECTION_CLICK = 'prd-dashboard__subjective-data-collection--click',
    _a.PRD_DASHBOARD_OBJECTIVE_DATA_COLLECTION_CLICK = 'prd-dashboard__objective-data-collection--click',
    _a.PRD_DASHBOARD_EDUCATION_AND_EMPATHY_CLICK = 'prd-dashboard__education-and-empathy--click',
    _a.PRD_DASHBOARD_CARE_PLAN_CLICK = 'prd-dashboard__care-plan--click',
    _a.PRD_DASHBOARD_COURSE_CATEGORY_DROPDOWN_EE_CLICK = 'prd-dashboard__course-category-dropdown-ee--click',
    _a.PRD_DASHBOARD_COURSE_CATEGORY_DROPDOWN_SDC_CLICK = 'prd-dashboard__course-category-dropdown-SDC--click',
    _a.PRD_DASHBOARD_COURSE_CATEGORY_EE_EDUCATION_TAB_CLICK = 'prd-dashboard__course-category-ee-education-tab--click',
    _a.PRD_DASHBOARD_COURSE_CATEGORY_EE_EMPATHY_TAB_CLICK = 'prd-dashboard__course-category-ee-empathy-tab--click',
    _a.PRD_DASHBOARD_COURSE_CATEGORY_EE_KEYWORD_SEARCH = 'prd-dashboard__course-category-ee-keyword--search',
    _a.PRD_DASHBOARD_COURSE_CATEGORY_SDC_KEYWORD_SEARCH = 'prd-dashboard__course-category-SDC-keyword--search',
    _a.PRD_DASHBOARD_COURSE_CATEGORY_EE_OPPORTUNITY_CLICK = 'prd-dashboard__course-category-ee-opportunity--click',
    _a.PRD_COURSE_DROPDOWN_CLICK = 'prd-course-dropdown--click',
    _a.PRD_SECTION_DROPDOWN_CLICK = 'prd-section-dropdown--click',
    _a.PRD_VIEW_ALL_COURSES_CLICK = 'prd-view-all-courses--click',
    _a.PRD_DASHBOARD_CATEGORY_STRENGTH_AND_WEAKNESSES_TAB_VIEW = 'prd-dashboard__category-strength-and-weaknesses-tab--view',
    _a.PRD_DASHBOARD_CJMM_TAB_VIEW = 'prd-dashboard__cjmm-tab--view',
    _a.PRD_DASHBOARD_ASSIGNMENT_SUMMARY_TAB_VIEW = 'prd-dashboard__assignment-summary-tab--view',
    _a.PRD_DASHBOARD_ASSIGNMENT_SUMMARY_SEARCH = 'prd-dashboard__assignment-summary-search',
    _a.PRD_DASHBOARD_CJMM_CLASS_ASSIGNMENT_VIEW_CLICK = 'prd-dashboard__cjmm-class-assignment-view--click',
    _a.PRD_DASHBOARD_CJMM_CONSTRUCT_CLICK = 'prd-dashboard__cjmm-construct--click',
    _a.PRD_DASHBOARD_CJMM_STUDENT_LIST_VIEW_CLICK = 'prd-dashboard__cjmm-student-list-view--click',
    _a.PRD_DASHBOARD_CJMM_VIEW_STUDENT_DROPDOWN_CLICK = 'prd-dashboard__cjmm-view-student-dropdown--click',
    _a.PRD_DASHBOARD_CJMM_RECOGNIZE_CUES_CONSTRUCT_CLICK = 'prd-dashboard__cjmm-recognize-cues-construct--click',
    _a.PRD_DASHBOARD_CJMM_ANALYZE_CUES_CONSTRUCT_CLICK = 'prd-dashboard__cjmm-analyze-cues-construct--click',
    _a.PRD_DASHBOARD_CJMM_PRIORITIZE_HYPOTHESIS_CONSTRUCT_CLICK = 'prd-dashboard__cjmm-prioritize-hypothesis-construct--click',
    _a.PRD_DASHBOARD_CJMM_EVALUATE_OUTCOMES_CONSTRUCT_CLICK = 'prd-dashboard__cjmm-evaluate-outcomes-construct--click',
    _a.PRD_DASHBOARD_CJMM_GENERATE_SOLUTIONS_CONSTRUCT_CLICK = 'prd-dashboard__cjmm-generate-solutions-construct--click',
    _a.PRD_DASHBOARD_CJMM_TAKE_ACTIONS_CONSTRUCT_CLICK = 'prd-dashboard__cjmm-take-actions-construct--click',
    _a.PRD_DASHBOARD_STUDENT_ENGAGEMENT_STUDENT_SEARCH = 'prd-dashboard__student-engagement-student--search',
    _a.PRD_DASHBOARD_STUDENT_PERFORMANCE_TAB_VIEW = 'prd-dashboard__student-performance-tab--view',
    _a.PRD_DASHBOARD_STUDENT_PERFORMANCE_STUDENT_NAME_SEARCH = 'prd-student-performance__student-name-search',
    _a.PRD_LANDING_PAGE_VIEW_ASSIGNMENT_DETAILS_ON_ASSIGNMENT_CLICK = 'prd-landing-page__view-assignment=details-on-assignment-name--click',
    _a.PRD_ASSIGNMENT_DETAILS_ASSIGNMENT_SELECT = 'prd-dashboard__assignment-details-assignment--select',
    _a.PRD_ASSIGNMENT_DETAILS_DCE_CLICK = 'prd-dashboard__assignment-details-dce--click',
    _a.PRD_ASSIGNMENT_DETAILS_SPI_CLICK = 'prd-dashboard__assignment-details-spi--click',
    _a.PRD_ASSIGNMENT_DETAILS_STUDENT_BELOW_BENCHMARK_CLICK = 'prd-dashboard__assignment-details-students-below-benchmark--click',
    _a.PRD_ASSIGNMENT_DETAILS_STUDENT_BELOW_CLASS_AVG_CLICK = 'prd-dashboard__students-below-class-avg--click',
    _a.PRD_ASSIGNMENT_DETAILS_STUDENT_PERFORMANCE_TAB_CLICK = 'prd-dashboard__assignment-details-student-performance-tab--click',
    _a.PRD_ASSIGNMENT_DETAILS_STUDENT_ENGAGEMENT_TAB_CLICK = 'prd-dashboard__assignment-details-student-engagement-tab--click',
    _a.PRD_ASSIGNMENT_DETAILS_STUDENT_PERFORMANCE_SEARCH = 'prd-dashboard__assignment-details-student-performance-search',
    _a.PRD_COURSE_AGGREGATE_SEARCH = 'prd-course-aggregate__search',
    _a.PRD_COURSE_AGGREGATE_SORT_BY_DROPDOWN_CLICK = 'prd-course-aggregate__sort-by-dropdown--click',
    _a.PRD_COURSE_AGGREGATE_COURSE_CLICK = 'prd-course-aggregate__course--click',
    _a.PRD_COURSE_AGGREGATE_BACK_BUTTON_CLICK = 'prd-course-aggregate__back-button--click',
    _a.PRD_STUDENT_DETAILS_DCE_CLICK = 'prd-student-details__dce--click',
    _a.PRD_STUDENT_DETAILS_SPI_CLICK = 'prd-student-details__spi--click',
    _a.PRD_STUDENT_DETAILS_ASSIGNMENT_BELOW_BENCHMARK_CLICK = 'prd-student-details__assignment-below-benchmark--click',
    _a.PRD_STUDENT_DETAILS_ASSIGNMENT_BELOW_CLASS_AVG_CLICK = 'prd-student-details__assignment-below-class-avg--click',
    _a.PRD_STUDENT_DETAILS_ASSIGNMENT_PERFORMANCE_TAB_VIEW = 'prd-student-details__assignment-performance-tab--view',
    _a.PRD_STUDENT_DETAILS_ASSIGNMENT_ENGAGEMENT_TAB_VIEW = 'prd-student-details__assignment-engagement-tab--view',
    _a.PRD_STUDENT_DETAILS_TRENDS_TAB_VIEW = 'prd-student-details__trends-tab--view',
    _a.PRD_STUDENT_DETAILS_STUDENT_SELECT = 'prd-student-details__student--select',
    _a.PRD_STUDENT_DETAILS_PERFORMANCE_ASSIGNMENT_SEARCH = 'prd-student-details__performance-assignment-search',
    _a.PRD_STUDENT_DETAILS_ENGAGEMENT_ASSIGNMENT_SEARCH = 'prd-student-details__engagement-assignment-search',
    _a.PRD_DASHBOARD_CATEGORY_TABLE_SDC_CATEGORY_DROPDOWN_CLICK = 'prd-table__sdc-category-dropdown--click',
    _a.PRD_DASHBOARD_CATEGORY_TABLE_SDC_SUB_CATEGORY_DROPDOWN_CLICK = 'prd-table__sdc-sub-category-dropdown--click',
    _a.PRD_DASHBOARD_COURSE_CATEGORY_DROPDOWN_ODC_CLICK = 'prd-dashboard__course-category-dropdown-odc--click',
    _a.PRD_DASHBOARD_COURSE_CATEGORY_ODC_KEYWORD_SEARCH = 'prd-dashboard__course-category-odc-keyword--search',
    _a.PRD_DASHBOARD_CATEGORY_TABLE_ODC_CATEGORY_DROPDOWN_CLICK = 'prd-dashboard__category-table-odc-category-dropdown--click',
    _a.PRD_DASHBOARD_CATEGORY_TABLE_DROPDOWN_CP_CLICK = 'prd-dashboard__category-table-dropdown_cp--click',
    _a.PRD_DASHBOARD_CATEGORY_TABLE_CP_KEYWORD_SEARCH = 'prd-dashboard__category-table-cp-keyword--search',
    _a.PRD_DASHBOARD_CATEGORY_TABLE_CP_CATEGORY_DROPDOWN_CLICK = 'prd-dashboard__category-table-cp-category-dropdown--click',
    _a.PRD_DASHBOARD_CATEGORY_TABLE_CP_SUB_CATEGORY_DROPDOWN_CLICK = 'prd-dashboard__category-table-cp-sub-category-dropdown--click',
    _a.BENTO_BOX_CW_LINK_CLICK = 'bento_box__cw_link--click',
    _a.BENTO_BOX_HAD_LINK_CLICK = 'bento_box__had_link--click',
    _a.BENTO_BOX_EHR_LINK_CLICK = 'bento_box__ehr_link--click',
    _a.BENTO_BOX_PRD_LINK_CLICK = 'bento_box__prd_link--click',
    _a.BENTO_BOX_PS_LINK_CLICK = 'bento_box__ps_link--click',
    _a.BENTO_BOX_DP_LINK_CLICK = 'bento_box__dp_link--click',
    _a.PAGE_HEADER_ACCESS_ALL_DASHBOARD_LINK_CLICK = 'page-header__access-all-dashboard-link__click',
    _a.PS_COURSE_SUMMARY_HESI_REVIEW_ACTIVE_COHORTS_LINK_CLICK = 'ps-course-summary__hesi-review-active-cohorts-link--click',
    _a.PS_COURSE_SUMMARY_SHERPATH_REVIEW_ACTIVE_COURSES_LINK_CLICK = 'ps-course-summary__sherpath-review-active-courses-link--click',
    _a.PS_COURSE_SUMMARY_SHADOW_HEALTH_REVIEW_ACTIVE_COURSES_LINK_CLICK = 'ps-course-summary__shadow-health-review-active-courses-link--click',
    _a.PS_STUDENT_PROFILE_BACK_BUTTON_CLICK = 'ps-student-profile__back-button--click',
    _a.PS_STUDENT_PROFILE_VIEW_STUDENT_ON_STUDENT_NAME_CLICK = 'ps-student-profile__view-student-on-student-name--click',
    _a.PS_STUDENT_PROFILE_SHADOW_HEALTH_ASSIGNMENTS_TAB_CLICK = 'ps-student-profile__shadow-health-assignments-tab--click',
    _a.PS_STUDENT_PROFILE_SHERPATH_ASSIGNMENTS_TAB_CLICK = 'ps-student-profile__sherpath-assignments-tab--click',
    _a.PS_STUDENT_PROFILE_HESI_EXAMS_TAB_CLICK = 'ps-student-profile__hesi-exams-tab--click',
    _a.PS_STUDENT_PROFILE_CATEGORY_PERFORMANCE_TAB_CLICK = 'ps-student-profile__category-performance-tab--click',
    _a.PS_STUDENT_PROFILE_TOPIC_AREA_PERFORMANCE_TAB_CLICK = 'ps-student-profile__topic-area-performance-tab--click',
    _a.PS_STUDENT_PROFILE_NGN_DETAILS_TAB_CLICK = 'ps-student-profile__ngn-details-tab--click',
    _a.PS_STUDENT_PROFILE_ADD_ADAPTIVE_QUIZ_BUTTON_CLICK = 'ps-student-profile__add-adaptive-quiz-button--click',
    _a.PS_STUDENT_PROFILE_RESOURCES_AVAILABLE_BUTTON_CLICK = 'ps-student-profile__resources-available-button--click',
    _a.PS_STUDENT_PROFILE_TOPIC_CARD_COLLAPSE_BUTTON_CLICK = 'ps-student-profile__topic-card-collapse-button--click',
    _a.PS_STUDENT_PROFILE_TOPIC_RESOURCES_TABLE_ADD_BUTTON_CLICK = 'ps-student-profile__topic-resources-table-add-button--click',
    _a.PS_STUDENT_PROFILE_ADD_NOTES_BUTTON_CLICK = 'ps-student-profile__add-notes-button--click',
    _a.PS_STUDENT_PROFILE_EXPORT_NOTES_BUTTON_CLICK = 'ps-student-profile__export-notes-button--click',
    _a.PS_STUDENT_PROFILE_EDIT_HESI_THRESHOLD_CLICK = 'ps-student-profile__edit-hesi-threshold--click',
    _a.PS_STUDENT_PROFILE_EDIT_HESI_EXAM_THRESHOLD_CLICK = 'ps-student-profile__edit-hesi-exam-threshold--click',
    _a.PS_STUDENT_PROFILE_HESI_EXAMS_TAB_EXPORT_BUTTON_CLICK = 'ps-student-profile__hesi-exams-tab-export-button--click',
    _a.PS_STUDENT_PROFILE_EAQ_TOPIC_TAB_EXPORT_BUTTON_CLICK = 'ps-student-profile__eaq-topic-tab-export-button--click',
    _a.PS_STUDENT_PROFILE_HESI_CATEGORY_TAB_EXPORT_BUTTON_CLICK = 'ps-student-profile__hesi-category-tab-export-button--click',
    _a.PS_LANDING_PAGE_HESI_COHORTS_CLICK = 'ps-landing-page__hesi-cohorts--click',
    _a.PS_LANDING_PAGE_SHERPATH_REVIEW_ACTIVE_COURSES_LINK_CLICK = 'ps-landing-page__sherpath-review-active-courses-link--click',
    _a.PS_LANDING_PAGE_SHADOW_HEALTH_REVIEW_ACTIVE_COURSES_LINK_CLICK = 'ps-landing-page__shadow-health-review-active-courses-link--click',
    _a.PS_LANDING_PAGE_EXAM_DETAIL_PAGE_CLICK = 'ps-landing-page__exam-detail-page--click',
    _a.PS_LANDING_PAGE_BACK_BUTTON_CLICK = 'ps-landing-page__back-button--click',
    _a.PS_LANDING_PAGE_VIEW_STUDENT_ON_STUDENT_NAME_CLICK = 'ps-landing-page__view-student-on-student-name--click',
    _a.PS_LANDING_PAGE_FILTER_MOST_RECENT_EXAMS_CLICK = 'ps-landing-page__filter-most-recent-exams--click',
    _a.PS_LANDING_PAGE_EDIT_HESI_EXAM_THRESHOLD_CLICK = 'ps-landing-page__edit-hesi-exam-threshold--click',
    _a.PS_INSTRUCTOR_LANDING_PAGE_EXPORT_BUTTON_CLICK = 'ps-instructor-landing-page__export-button--click',
    _a.CRPA_BACK_TO_REFERRING_PAGE_CLICK = 'crpa__back-to-referring-page--click',
    _a.CPRA_STUDENTS_BELLOW_PROFICIENT_CLICK = 'cpra__students-bellow-proficient--click',
    _a.CPRA_ASSESSMENT_CLICK = 'cpra__assessment--click',
    _a.CPRA_COMMUNICATION_CLICK = 'cpra__communication--click',
    _a.CPRA_CLINICAL_JUDGMENT_CLICK = 'cpra__clinical-judgment--click',
    _a.CPRA_EDUCATION_CLICK = 'cpra__education--click',
    _a.CPRA_SAFETY_CLICK = 'cpra__safety--click',
    _a.CPRA_STUDENT_NAME_SEARCH = 'cpra__student-name-search',
    _a.CPRA_EMERGING_FILTER_CLICK = 'cpra__emerging-filter--click',
    _a.CPRA_DEVELOPING_FILTER_CLICK = 'cpra__developing-filter--click',
    _a.CPRA_PROFICIENT_FILTER_CLICK = 'cpra__proficient-filter--click',
    _a.CPRA_ADVANCED_FILTER_CLICK = 'cpra__advanced-filter--click',
    _a.CW_GRADEBOOK_BENCHMARK_ENABLED_CLICK = 'cw-gradebook-benchmark-enabled--click',
    _a.CW_GRADEBOOK_BENCHMARK_ADJUSTMENT_CLICK = 'cw-gradebook-benchmark-adjustment--click',
    _a.CW_STUDENT_ASSIGNMENT_SUMMARY_TABLE_VIEW_ALL_ATTEMPTS_CLICK = 'cw-student-assignment-summary-table-view-all-attempts--click',
    _a.HESI_NG_EXAM_SELECTOR_DROPDOWN_CLICK = 'hesi-ng-exam-selector-dropdown--click',
    _a.HESI_NG_EXAMGROUP_SELECTOR_DROPDOWN_CLICK = 'hesi-ng-exam-group-selector-dropdown--click',
    _a.HESI_NG_STUDENT_SEARCH_CLICK = 'hesi-ng-student-search--click',
    _a.HESI_NG_STUDENT_PERFORMANCE_TAB_CLICK = 'hesi-ng-student-performance-tab--click',
    _a.HESI_NG_STUDENT_PERFORMANCE_FILTER_BUTTON_CLICK = 'hesi-ng-student-performance-filter-button--click',
    _a.HESI_NG_STUDENT_PERFORMANCE_SEARCH_CLICK = 'hesi-ng-student-performance-search--click',
    _a.HESI_NG_CATEGORY_RESULTS_TAB_CLICK = 'hesi-ng-category-results-tab--click',
    _a.HESI_NG_CATEGORY_PERFORMANCE_SUBTAB_CLICK = 'hesi-ng-category-performance-subtab--click',
    _a.HESI_NG_CATEGORY_AND_ITEMS_RESULTS_TAB_CLICK = 'hesi-ng-category-and-items-results-tab--click',
    _a.HESI_NG_CATEGORY_AND_ITEMS_RESULTS_CATEGORY_PERFORMANCE_TAB_CLICK = 'hesi-ng-category-and-items-results-category-performance-tab--click',
    _a.HESI_NG_CATEGORY_AND_ITEMS_RESULTS_ITEM_DETAILS_TAB_CLICK = 'hesi-ng-category-and-items-results-item-details-tab--click',
    _a.HESI_NG_ITEM_DETAILS_SUBTAB_CLICK = 'hesi-ng-item-details-subtab--click',
    _a.HESI_NG_NGN_TAB_CLICK = 'hesi-ng-ngn-tab--click',
    _a.HESI_NG_NGN_ITEM_TYPE_DETAILS_SUBTAB_CLICK = 'hesi-ng-ngn-item-type-details-subtab--click',
    _a.HESI_NG_NGN_ITEM_DETAILS_SUBTAB_CLICK = 'hesi-ng-ngn-item-details-subtab--click',
    _a.HESI_NG_PRINT_BUTTON_CLICK = 'hesi-ng-print-button--click',
    _a.HESI_HP_EXAM_RESULTS_PAGE_STUDENT_PERFORMANCE_TAB_CLICK = 'hesi-hp-exam-results-page__student-performance-tab--click',
    _a.HESI_HP_EXAM_RESULTS_PAGE_STUDENT_PERFORMANCE_TAB_STUDENT_SEARCH = 'hesi-hp-exam-results-page__student-performance-tab-student--search',
    _a.HESI_HP_EXAM_RESULTS_PAGE_STUDENT_PERFORMANCE_TAB_FILTER_BUTTON_CLICK = 'hesi-hp-exam-results-page__student-performance-tab-filter-button--click',
    _a.HESI_HP_EXAM_RESULTS_PAGE_CATEGORY_AND_ITEM_RESULTS_TAB_CLICK = 'hesi-hp-exam-results-page__category-and-item-results-tab--click',
    _a.HESI_HP_EXAM_RESULTS_PAGE_CATEGORY_AND_ITEM_RESULTS_CATEGORY_PERFORMANCE_TAB_CLICK = 'hesi-hp-exam-results-page__category-and-item-results-category-performance-tab--click',
    _a.HESI_HP_EXAM_RESULTS_PAGE_CATEGORY_AND_ITEM_RESULTS_ITEM_DETAILS_TAB_CLICK = 'hesi-hp-exam-results-page__category-and-item-results-item-details-tab--click',
    _a.HESI_A2_EXAM_RESULTS_PAGE_STUDENT_PERFORMANCE_TAB_CLICK = 'hesi-a2-exam-results-page__student-performance-tab--click',
    _a.HESI_A2_EXAM_RESULTS_PAGE_SUBJECT_AREA_RESULTS_TAB_CLICK = 'hesi-a2-exam-results-page__subject-area-results-tab--click',
    _a.HESI_A2_EXAM_RESULTS_PAGE_STUDENT_PERFORMANCE_TAB_STUDENT_SEARCH = 'hesi-a2-exam-results-page__student-performance-tab-student--search',
    _a.EXPORT_BUTTON_CLICK = 'export-button--click',
    _a.PSD_DEAN_NEEDS_ATTENTION_CLICK = 'psd-dean-needs-attention--click',
    _a.PSD_DEAN_INSTITUTION_WEAKEST_CATEGORIES_CLICK = 'psd_dean_institution_weakest_categories--click',
    _a.PSD_DEAN_CAMPUS_WEAKEST_CATEGORIES_CLICK = 'psd_dean_campus_weakest_categories--click',
    _a.PSD_DEAN_INSTITUTION_WEAKEST_CATEGORIES_FILTER = 'psd_dean_institution_weakest_categories_filter',
    _a.PSD_DEAN_CAMPUS_WEAKEST_CATEGORIES_FILTER = 'psd_dean_campus_weakest_categories_filter',
    _a.PSD_DEAN_WEAKEST_CATEGORY_CLICK = 'psd_dean_weakest_category--click',
    _a.DP_DEAN_HOME_TAKE_A_TOUR_CLICK = 'dp-dean-home__take-a-tour--click',
    _a.PSD_DEAN_CAMPUS_CARD_CLICK = 'psd_dean_campus_card--click',
    _a.PSD_DEAN_PROGRAM_CARD_CLICK = 'psd_dean_program_card--click',
    _a.PSD_DEAN_CAMPUS_CARD_A2_CLICK = 'psd_dean_campus_card_a2--click',
    _a.PSD_DEAN_INSTITUTION_CARD_A2_CLICK = 'psd_dean_institution_card_a2--click',
    _a.PSD_DEAN_INSTITUTION_SUMMARY_CATEGORY_REPORT_CLICK = 'psd_dean_institution_summary_category_report--click',
    _a.PSD_DEAN_PROGRAM_TAB_CLICK = 'psd_dean_program_tab--click',
    _a.PSD_DEAN_VIEW_BY_COHORT_CLICK = 'psd_dean_view_by_cohort--click',
    _a.PSD_DEAN_FILTER_BUTTON_CLICK = 'psd_dean_filter_button--click',
    _a.PSD_DEAN_FILTER_FIELD_CHANGE_CLICK = 'psd_dean_filter_field_change--click',
    _a.PSD_DEAN_FILTER_APPLY_CLICK = 'psd_dean_filter_apply--click',
    _a.PSD_DEAN_FILTER_RESET_CLICK = 'psd_dean_filter_reset--click',
    _a.PSD_DEAN_THRESHOLDS_OVERVIEW_OPEN = 'psd_dean_thresholds_overview_open--click',
    _a.PSD_DEAN_PROGRAM_DETAIL_CATEGORY_DRAWER_EXPORT_CLICK = 'psd_dean_program_detail_category_drawer_export--click',
    _a.PSD_DEAN_NEED_ATTENTION_PIN_CLICK = 'psd-dean-needs-attention-pin--click',
    _a.PSD_DEAN_NEED_ATTENTION_UNPIN_CLICK = 'psd-dean-needs-attention-unpin--click',
    _a.PSD_DEAN_PROGRAM_CARD_PIN_CLICK = 'psd-dean-program-card-pin--click',
    _a.PSD_DEAN_PROGRAM_CARD_UNPIN_CLICK = 'psd-dean-program-card-unpin--click',
    _a.PSD_DEAN_PROGRAM_HESI_SCORE_CARD_PIN_CLICK = 'psd-dean-program-hesi-score-card-pin--click',
    _a.PSD_DEAN_PROGRAM_HESI_SCORE_CARD_UNPIN_CLICK = 'psd-dean-program-hesi-score-card-unpin--click',
    _a.PSD_DEAN_INSTITUTION_WEAKNESS_CATEGORY_PIN_CLICK = 'psd-dean-institution-weakness-category-pin--click',
    _a.PSD_DEAN_INSTITUTION_WEAKNESS_CATEGORY_UNPIN_CLICK = 'psd-dean-institution-weakness-category-unpin--click',
    _a.PSD_DEAN_CAMPUS_WEAKNESS_CATEGORY_PIN_CLICK = 'psd-dean-campus-weakness-category-pin--click',
    _a.PSD_DEAN_CAMPUS_WEAKNESS_CATEGORY_UNPIN_CLICK = 'psd-dean-campus-weakness-category-unpin--click',
    _a.PSD_DEAN_CAMPUS_HESI_INCREASE_PIN_CLICK = 'psd-dean-campus-hesi-increase-pin--click',
    _a.PSD_DEAN_CAMPUS_HESI_INCREASE_UNPIN_CLICK = 'psd-dean-campus-hesi-increase-unpin--click',
    _a.PSD_DEAN_MEAN_HESI_EXIT_SCORES_PIN_CLICK = 'psd-dean-mean-hesi-exit-scores-pin--click',
    _a.PSD_DEAN_MEAN_HESI_EXIT_SCORES_UNPIN_CLICK = 'psd-dean-mean-hesi-exit-scores-unpin--click',
    _a.PSD_DEAN_PROGRAM_SUMMARY_PAGE_HESI_TERM_CHANGE = 'psd_dean_program_summary_page_hesi_term--change',
    _a.PSD_DEAN_PROGRAM_SUMMARY_PAGE_ENGAGEMENT_TIMEWINDOW_CHANGE = 'psd_dean_program_summary_page_engagement_timewindow--change',
    _a.PSD_DEAN_ENGAGEMENT_OVERVIEW_PIN_CLICK = 'psd-dean-engagement-overview-pin--click',
    _a.PSD_DEAN_ENGAGEMENT_OVERVIEW_UNPIN_CLICK = 'psd-dean-engagement-overview-unpin--click',
    _a.PSD_DEAN_INSTITUTION_THRESHOLDS_MODAL_OPEN_CLICK = 'psd_dean_institution_thresholds_modal_open--click',
    _a.PSD_DEAN_INSTITUTION_THRESHOLDS_CHANGE_CLICK = 'psd_dean_institution_thresholds_change--click',
    _a.PSD_DEAN_INSTITUTION_THRESHOLDS_SAVE_CLICK = 'psd_dean_institution_thresholds_save--click',
    _a.PSD_DEAN_INSTITUTION_THRESHOLDS_CANCEL_CLICK = 'psd_dean_institution_thresholds_cancel--click',
    _a.PSD_DEAN_CAMPUS_THRESHOLDS_MODAL_OPEN_CLICK = 'psd_dean_campus_thresholds_modal_open--click',
    _a.PSD_DEAN_CAMPUS_THRESHOLDS_CHANGE_CLICK = 'psd_dean_campus_thresholds_change--click',
    _a.PSD_DEAN_CAMPUS_THRESHOLDS_SAVE_CLICK = 'psd_dean_campus_thresholds_save--click',
    _a.PSD_DEAN_CAMPUS_THRESHOLDS_CANCEL_CLICK = 'psd_dean_campus_thresholds_cancel--click',
    _a.PSD_DEAN_PROGRAM_THRESHOLDS_MODAL_OPEN_CLICK = 'psd_dean_program_thresholds_modal_open--click',
    _a.PSD_DEAN_PROGRAM_THRESHOLDS_CHANGE_CLICK = 'psd_dean_program_thresholds_change--click',
    _a.PSD_DEAN_PROGRAM_THRESHOLDS_SAVE_CLICK = 'psd_dean_program_thresholds_save--click',
    _a.PSD_DEAN_PROGRAM_THRESHOLDS_CANCEL_CLICK = 'psd_dean_program_thresholds_cancel--click',
    _a.PSD_DEAN_PROGRAM_DETAIL_VIEW_ALL_THRESHOLDS_CLICK = 'psd_dean_program_detail_view_all_thresholds--click',
    _a.PSD_DEAN_CATEGORY_PIN_CLICK = 'psd-dean-category-pin--click',
    _a.PSD_DEAN_CATEGORY_UNPIN_CLICK = 'psd-dean-category-unpin--click',
    _a.PSD_DEAN_CATEGORY_PINS_VIEW_TOGGLE_ENABLED_CLICK = 'psd-dean-category-pins-view-toggle-enabled--click',
    _a.PSD_DEAN_CATEGORY_PINS_VIEW_TOGGLE_DISABLED_CLICK = 'psd-dean-category-pins-view-toggle-disabled--click',
    _a.PSD_DEAN_CATEGORY_MANAGE_OPEN_CLICK = 'psd_dean_category_manage-open--click',
    _a.PSD_DEAN_CATEGORY_MANAGE_SAVE_CLICK = 'psd_dean_category_manage-save--click',
    _a.PSD_DEAN_CATEGORY_MANAGE_CANCEL_CLICK = 'psd_dean_category_manage-cancel--click',
    _a.PSD_DEAN_CATEGORY_REORDER_DRAG = 'psd_dean_category-reorder--drag',
    _a.PSD_DEAN_HOME_PINS_REORDER_DRAG = 'psd_dean_home_pins_reorder--drag',
    _a.PSD_DEAN_CAMPUS_CARD_PIN_CLICK = 'psd-dean-campus-card-pin--click',
    _a.PSD_DEAN_CAMPUS_CARD_UNPIN_CLICK = 'psd-dean-campus-card-unpin--click',
    _a.PSD_DEAN_CAMPUS_PROGRAM_CARD_PIN_CLICK = 'psd-dean-campus-program-card-pin--click',
    _a.PSD_DEAN_CAMPUS_PROGRAM_CARD_UNPIN_CLICK = 'psd-dean-campus-program-card-unpin--click',
    _a.PSD_DEAN_CAMPUS_PROGRAM_HESI_BELOW850_CLICK = 'psd_dean_campus_page_program_hesi_below850--click',
    _a.PSD_DEAN_CAMPUS_PROGRAM_SHERPATH_ENGAGEMENT_CLICK = 'psd_dean_campus_page_program_sherpath_engagement--click',
    _a.PSD_DEAN_CAMPUS_PROGRAM_EAQ_SELF_STUDY_CLICK = 'psd_dean_campus_page_program_eaq_self_study--click',
    _a.PSD_DEAN_CAMPUS_PROGRAM_PRESCRIPTION_FOR_SUCCESS_CLICK = 'psd_dean_campus_page_program_prescription_for_success--click',
    _a.PSD_DEAN_STUDENTS_BELOW_THRESHOLD_PIN_CLICK = 'psd-dean-students-below-threshold-pin--click',
    _a.PSD_DEAN_STUDENTS_BELOW_THRESHOLD_UNPIN_CLICK = 'psd-dean-students-below-threshold-unpin--click',
    _a.PSD_DEAN_CAMPUS_CARD_LANDING_PAGE_CLICK = 'psd_dean_campus_card_landing_page--click',
    _a.PSD_DEAN_CAMPUS_HESI_INCREASE_CARD_LANDING_PAGE_CLICK = 'psd_dean_campus_hesi_increase_card_landing_page--click',
    _a.PSD_DEAN_STUDENTS_BELOW_THRESHOLD_CARD_LANDING_PAGE_CLICK = 'psd_dean_students_below_threshold_card_landing_page--click',
    _a.PSD_DEAN_HESI_SCORE_SUMMARY_CARD_LANDING_PAGE_CLICK = 'psd_dean_hesi_score_summary_card_landing_page--click',
    _a.PSD_DEAN_PROGRAM_SUMMARY_CARD_LANDING_PAGE_CLICK = 'psd_dean_program_summary_card_landing_page--click',
    _a.PSD_DEAN_NEED_ATTENTION_CARD_LANDING_PAGE_CLICK = 'psd_dean_need_attention_card_landing_page--click',
    _a.PSD_DEAN_CAMPUS_PROGRAM_CARD_LANDING_PAGE_CLICK = 'psd_dean_campus_program_card_landing_page--click',
    _a.PSD_DEAN_CAMPUS_PAGE_DRAWER_TAB_STUDENTS_BELOW_850_CLICK = 'psd_dean_campus_page_drawer_tab_students_below_850--click',
    _a.PSD_DEAN_CAMPUS_PAGE_DRAWER_TAB_SHERPATH_STUDENT_ENGAGEMENT_CLICK = 'psd_dean_campus_page_drawer_tab_sherpath_student_engagement--click',
    _a.PSD_DEAN_CAMPUS_PAGE_DRAWER_TAB_PRESCRIPTION_FOR_SUCCESS_CLICK = 'psd_dean_campus_page_drawer_tab_prescription_for_success--click',
    _a.PSD_DEAN_CAMPUS_PAGE_DRAWER_TAB_SHERPATH_AI_CLICK = 'psd_dean_campus_page_drawer_tab_sherpath_ai--click',
    _a.PSD_DEAN_CAMPUS_PAGE_DRAWER_SHERPATH_AI_TIMEWINDOW_CHANGE = 'psd_dean_campus_page_drawer_sherpath_ai_timewindow--change',
    _a.PSD_DEAN_CAMPUS_PAGE_DRAWER_CLOSE = 'psd_dean_campus_page_drawer_close--click',
    _a.PSD_DEAN_CAMPUS_PAGE_DRAWER_PROGRAM_LINK_CLICK = 'psd_dean_campus_page_drawer_program_link--click',
    _a.PSD_DEAN_CAMPUS_PAGE_DRAWER_STUDENTS_BELOW_850_SORT_CHANGE = 'psd_dean_campus_page_drawer_students_below_850_sort--change',
    _a.PSD_DEAN_CAMPUS_PAGE_DRAWER_STUDENTS_BELOW_850_ROW_CLICK = 'psd_dean_campus_page_drawer_students_below_850_row--click',
    _a.PSD_DEAN_CAMPUS_PAGE_DRAWER_SHERPATH_ENGAGEMENT_SORT_CHANGE = 'psd_dean_campus_page_drawer_sherpath_engagement_sort--change',
    _a.PSD_DEAN_CAMPUS_PAGE_DRAWER_SHERPATH_ENGAGEMENT_ROW_CLICK = 'psd_dean_campus_page_drawer_sherpath_engagement_row--click',
    _a.PSD_DEAN_CAMPUS_PAGE_DRAWER_PRESCRIPTION_FOR_SUCCESS_SORT_CHANGE = 'psd_dean_campus_page_drawer_prescription_for_success_sort--change',
    _a.PSD_DEAN_CAMPUS_PAGE_DRAWER_PRESCRIPTION_FOR_SUCCESS_ROW_CLICK = 'psd_dean_campus_page_drawer_prescription_for_success_row--click',
    _a.PSD_DEAN_WEAKEST_CATEGORIES_CARD_LANDING_PAGE_CLICK = 'psd_dean_weakest_categories_card_landing_page--click',
    _a.PSD_DEAN_CAMPUS_CARD_HIDE_STUDENTS_BELOW_THRESHOLD = 'psd_dean_campus_card_hide_students_below_threshold--click',
    _a.PSD_DEAN_CAMPUS_CARD_HIDE_AVG_A2_SCORE = 'psd_dean_campus_card_hide_avg_a2_score--click',
    _a.PSD_DEAN_CAMPUS_CARD_HIDE_HESI_SCORE_CHANGE = 'psd_dean_campus_card_hide_hesi_score_change--click',
    _a.PSD_DEAN_CAMPUS_CARD_HIDE_SHERPATH_INSTRUCTORS_ASSIGNING = 'psd_dean_campus_card_hide_sherpath_instructors_assigning--click',
    _a.PSD_DEAN_CAMPUS_CARD_HIDE_SHERPATH_STUDENTS_ENGAGING = 'psd_dean_campus_card_hide_sherpath_students_engaging--click',
    _a.PSD_DEAN_CAMPUS_CARD_HIDE_SHERPATH_AI_USAGE = 'psd_dean_campus_card_hide_sherpath_ai_usage--click',
    _a.PSD_DEAN_CAMPUS_CARD_RESET = 'psd_dean_campus_card_reset--click',
    _a.PSD_DEAN_PROGRAM_DETAIL_SHERPATH_SELF_STUDY_SORT_CHANGE = 'psd_dean_program_detail_sherpath_self_study_sort_change--select',
    _a.PSD_DEAN_PROGRAM_DETAIL_SHERPATH_SELF_STUDY_ROW_CLICK = 'psd_dean_program_detail_sherpath_self_study_row--click',
    _a.PSD_DEAN_PROGRAM_DETAIL_SHERPATH_VISIBLE_LESSONS_SORT_CHANGE = 'psd_dean_program_detail_sherpath_visible_lessons_sort_change--select',
    _a.PSD_DEAN_PROGRAM_DETAIL_SHERPATH_VISIBLE_LESSONS_ROW_CLICK = 'psd_dean_program_detail_sherpath_visible_lessons_row--click',
    _a.PSD_DEAN_PROGRAM_DETAIL_SHERPATH_PRESCRIPTION_SORT_CHANGE = 'psd_dean_program_detail_sherpath_prescription_for_success_sort_change--select',
    _a.PSD_DEAN_PROGRAM_DETAIL_SHERPATH_PRESCRIPTION_ROW_CLICK = 'psd_dean_program_detail_sherpath_prescription_for_success_row--click',
    _a.PSD_DEAN_PROGRAM_DETAIL_SHERPATH_CARD_VISIBLE_LESSONS_CLICK = 'psd_dean_program_detail_sherpath_card_visible_lessons--click',
    _a.PSD_DEAN_PROGRAM_DETAIL_SHERPATH_CARD_SELF_STUDY_CLICK = 'psd_dean_program_detail_sherpath_card_self_study--click',
    _a.PSD_DEAN_PROGRAM_DETAIL_SHERPATH_CARD_PRESCRIPTION_FOR_SUCCESS_CLICK = 'psd_dean_program_detail_sherpath_card_prescription_for_success--click',
    _a.PSD_DEAN_PROGRAM_DETAIL_SUBTAB_HESI_CLICK = 'psd_dean_program_detail_subtab_hesi--click',
    _a.PSD_DEAN_PROGRAM_DETAIL_SUBTAB_SHERPATH_CLICK = 'psd_dean_program_detail_subtab_sherpath--click',
    _a.PSD_DEAN_PROGRAM_DETAIL_SUBTAB_SHADOW_HEALTH_CLICK = 'psd_dean_program_detail_subtab_shadow_health--click',
    _a.PSD_DEAN_PROGRAM_DETAIL_SUBTAB_SHERPATH_AI_CLICK = 'psd_dean_program_detail_subtab_sherpath_ai--click',
    _a.PSD_DEAN_PROGRAM_DETAIL_SHADOW_HEALTH_SORT_CHANGE = 'psd_dean_program_detail_shadow_health_sort_change--select',
    _a.PSD_DEAN_PROGRAM_DETAIL_SHADOW_HEALTH_SEARCH = 'psd_dean_program_detail_shadow_health_search--click',
    _a.PSD_DEAN_PROGRAM_DETAIL_SHADOW_HEALTH_COURSE_CLICK = 'psd_dean_program_detail_shadow_health_course--click',
    _a.PSD_DEAN_PROGRAM_DETAIL_SHADOW_HEALTH_DISTRIBUTION_BUCKET_CLICK = 'psd_dean_program_detail_shadow_health_distribution_bucket--click',
    _a.PSD_DEAN_PROGRAM_DETAIL_SHERPATH_AI_TIMEWINDOW_CHANGE = 'psd_dean_program_detail_sherpath_ai_timewindow_change--select',
    _a.PSD_DEAN_PROGRAM_DETAIL_SHERPATH_AI_TOP_THEMES_NEXT = 'psd_dean_program_detail_sherpath_ai_top_themes_next--click',
    _a.PSD_DEAN_PROGRAM_DETAIL_SHERPATH_AI_TOP_THEMES_PREV = 'psd_dean_program_detail_sherpath_ai_top_themes_prev--click',
    _a.PSD_DEAN_PROGRAM_CARD_HIDE_HESI_MEAN_SCORE = 'psd_dean_program_card_hide_hesi_mean_score--click',
    _a.PSD_DEAN_PROGRAM_CARD_HIDE_HESI_STUDENTS_BELOW_THRESHOLD = 'psd_dean_program_card_hide_hesi_students_below_threshold--click',
    _a.PSD_DEAN_PROGRAM_CARD_HIDE_SHERPATH_ENGAGEMENT = 'psd_dean_program_card_hide_sherpath_engagement--click',
    _a.PSD_DEAN_PROGRAM_CARD_HIDE_SHERPATH_EAQ_SELF_STUDY = 'psd_dean_program_card_hide_sherpath_eaq_self_study--click',
    _a.PSD_DEAN_PROGRAM_CARD_HIDE_SHERPATH_PRESCRIPTION_FOR_SUCCESS = 'psd_dean_program_card_hide_sherpath_prescription_for_success--click',
    _a.PSD_DEAN_PROGRAM_CARD_HIDE_SHADOW_HEALTH_MOST_PRACTICED_SIMULATION = 'psd_dean_program_card_hide_shadow_health_most_practiced_simulation--click',
    _a.PSD_DEAN_PROGRAM_CARD_HIDE_SHADOW_HEALTH_AVG_SIMULATIONS_ASSIGNED = 'psd_dean_program_card_hide_shadow_health_avg_simulations_assigned--click',
    _a.PSD_DEAN_PROGRAM_CARD_RESET = 'psd_dean_program_card_reset--click',
    _a.PSD_DEAN_PROGRAM_SUMMARY_TOP_BOTTOM_SPECIALTY_CHANGE = 'psd_dean_program_summary_page_top_bottom_specialty--change',
    _a.PSD_DEAN_PROGRAM_SUMMARY_TOP_BOTTOM_TAB_CLICK = 'psd_dean_program_summary_page_top_bottom_tab--click',
    _a.PSD_DEAN_PROGRAM_SUMMARY_TOP_BOTTOM_VIEW_ALL_METRICS_CLICK = 'psd_dean_program_summary_page_top_bottom_view_all_metrics--click',
    _a.PSD_DEAN_PROGRAM_SUMMARY_TOP_BOTTOM_DRAWER_SPECIALTY_CHANGE = 'psd_dean_program_summary_page_drawer_11_metrics_specialty_change',
    _a.PSD_DEAN_PROGRAM_SUMMARY_TOP_BOTTOM_DRAWER_TAB_MED_SURG_CLICK = 'psd_dean_program_summary_page_drawer_11_metrics_tab_med_surg_click',
    _a.PSD_DEAN_PROGRAM_SUMMARY_TOP_BOTTOM_DRAWER_TAB_FUNDAMENTALS_CLICK = 'psd_dean_program_summary_page_drawer_11_metrics_tab_fundamentals_click',
    _a.PSD_DEAN_PROGRAM_SUMMARY_TOP_BOTTOM_DRAWER_TAB_PHARMACOLOGY_CLICK = 'psd_dean_program_summary_page_drawer_11_metrics_tab_pharmacology_click',
    _a.PSD_DEAN_PROGRAM_SUMMARY_TOP_BOTTOM_DRAWER_METRIC_INFO_CLICK = 'psd_dean_program_summary_page_drawer_11_metrics_info_click',
    _a.PSD_DEAN_PROGRAM_SUMMARY_TOP_BOTTOM_DRAWER_CLOSE = 'psd_dean_program_summary_page_drawer_11_metrics_close',
    _a.USPD_STUDENT_DETAIL_DROPDOWN_TAB_CHANGE = 'uspd-student-detail-dropdown-tab--change',
    _a.USPD_STUDENT_DETAIL_DROPDOWN_STUDENT_CHANGE = 'uspd-student-detail-dropdown-student--change',
    _a.HRND_COHORT_DETAIL_EXAM_RESULTS_TAB_CUSTOM_BENCHMARK_CLICK = 'hrnd-cohort-detail__exam-results-tab-custom-benchmark--click',
    _a.HRND_COHORT_DETAIL_CATEGORY_TAB_CUSTOM_BENCHMARK_CLICK = 'hrnd-cohort-detail__category-tab-custom-benchmark--click',
    _a);
export var Language = {
    DEFAULT_LOCALE: 'en'
};
export var DATE_FORMAT = 'MM-DD-YYYY';
export var SHORT_DATE_FORMAT = 'M/D/YY';
export var DATE_FORMAT_SECONDARY = 'MMM YYYY';
export var TABLE_FILTER_DATE_FORMAT = 'MM/DD/YY';
/* date-fns equivalent of TABLE_FILTER_DATE_FORMAT, required by @els/els-react--date-picker */
export var TABLE_FILTER_DATE_PICKER_FORMAT = 'MM/dd/yy';
/* format for react-datepicker require */
export var TABLE_FILTER_MONTH_YEAR_FORMAT = 'MM/yyyy';
export var TABLE_FILTER_MONTH_YEAR_DISPLAY_FORMAT = 'mm/yyyy';
export var TABLE_FILTER_DATE_EVENT = {
    startDateChange: 'startDateChange',
    endDateChange: 'endDateChange'
};
export var ALL_MENU_OPTION = 'all';
export var LOCALE_PLACEHOLDER = 'LOCALE_PLACEHOLDER';
export var X_TOKEN_COOKIE = 'x-token';
export var X_LINK_ID_COOKIE = 'x-link-id';
export var ADOBE_PRODUCT_CODE = {
    HAD_DASHBOARD: 'had',
    SHERPATH_COURSEWARE: 'scwp'
};
// TODO: revert new pendo key of INS-866, commented this line for later use
export var pendoAPIKey = 'd8168c6c-a23b-4081-6add-48a5809ba64f';
// export const pendoAPIKey = '53af6ed6-345d-472a-7063-45350c27de7c'; //old key -- keep until 2022/04/01
export var ROLE_KEY = 'user_role';
export var KEY_CODES = {
    UP: 38,
    DOWN: 40,
    ENTER: 13,
    TAB: 9,
    SPACE: 32,
    ESC: 27
};
export var PRESS_KEYS = {
    ESCAPE: 'Escape',
    TAB: 'Tab',
    DOWN: 'Down',
    UP: 'Up',
    SPACE: 'Space',
    ENTER: 'Enter',
    ARROW_UP: 'ArrowUp',
    ARROW_DOWN: 'ArrowDown',
    ARROW_LEFT: 'ArrowLeft',
    ARROW_RIGHT: 'ArrowRight',
    HOME: 'Home',
    END: 'End'
};
export var SORT_DIRECTION = {
    ASC: 'asc',
    DESC: 'desc'
};
export var SORT_DIRECTION_ARIA_LABEL = {
    asc: 'ascending',
    desc: 'descending'
};
export var SORT_DIRECTION_ENUM;
(function (SORT_DIRECTION_ENUM) {
    SORT_DIRECTION_ENUM["asc"] = "asc";
    SORT_DIRECTION_ENUM["desc"] = "desc";
})(SORT_DIRECTION_ENUM || (SORT_DIRECTION_ENUM = {}));
export var PAGE_NAMES = {
    ASSIGNMENT_SUMMARY: 'assignmentSummaryPage',
    GRADEBOOK: 'gradebookPage'
};
export var USER_ROLE = {
    EOLS_INSTRUCTOR: 'Ins',
    EVOLVE_INSTRUCTOR: 'faculty',
    STUDENT: 'Stu'
};
export var USER_ENHANCED_ROLE = {
    DEAN: 'dean'
};
export var SYSTEM_ID = {
    EOLS: 'eols',
    EVOLVE: 'evo'
};
export var EAQ_ISBN = 'EPRODUCT';
export var HESI_EXAM = 'HESI_EXAM';
export var TAB_NAV_ITEMS_NAME = {
    PERFORMANCE_SUMMARY: 'Performance Summary',
    GRADEBOOK: 'Gradebook',
    ASSIGNMENT_ENGAGEMENT: 'Assignment Engagement',
    ASSIGNMENT_SUMMARY: 'Assignment Summary',
    DISENGAGED_STUDENT: 'Disengaged Student',
    ASSESSMENT_SUMMARY: 'Assessment Summary',
    EAQ_TOPIC_REPORT: 'EAQ Topic Report',
    HESI_SPECIALTY_EXAM_READINESS: 'HESI Specialty Exam Readiness'
};
export var APP_DEFAULT_NAV_ITEMS = {
    default: [
        { name: TAB_NAV_ITEMS_NAME.PERFORMANCE_SUMMARY, paths: [RoutePath.home, RoutePath.cwIns] },
        { name: TAB_NAV_ITEMS_NAME.GRADEBOOK, paths: [PerformancePath.gradeBook.home] },
        { name: TAB_NAV_ITEMS_NAME.ASSIGNMENT_ENGAGEMENT, paths: __spreadArray([PerformancePath.engagementSummary], Object.values(PerformancePath.engagement), true) },
        { name: TAB_NAV_ITEMS_NAME.ASSIGNMENT_SUMMARY, paths: [PerformancePath.assignmentSummary] }
    ],
    expand: [],
    extraActive: [{ name: TAB_NAV_ITEMS_NAME.DISENGAGED_STUDENT, paths: [PerformancePath.disengagedStudent.home] }]
};
export var UI_EVENTS = {
    scrollToTable: 'scrollToTable'
};
export var STUDENT_DETAIL_APP_LINK = Object.freeze({
    CW: {
        title: 'View Sherpath Performance & Engagement',
        link: PerformancePath.studentDetail
    },
    HAD: {
        title: 'View HESI Readiness for NCLEX',
        link: HAD_PATHS === null || HAD_PATHS === void 0 ? void 0 : HAD_PATHS.studentDetail
    }
});
export var FULFILLED_STATUS = 'fulfilled';
export var REPORT_TITLE = {
    SHERPATH_PERFORMANCE_GRADES: {
        description: 'How are my students engaging with Sherpath learning?',
        title: 'Sherpath Performance & Grades Dashboard',
        backTo: 'Sherpath',
        disabledDescription: "This dashboard is only available to Sherpath users. If you are interested in using\n    Sherpath for your nursing program contact your administrator or Elsevier Sales Representative",
        defaultTitle: 'Performance & Grades Dashboard'
    },
    HESI_SPECIALTY_EXAM_READINESS: {
        description: 'How are my students mastering EAQ in HESI Focus Chapters?',
        title: 'HESI Specialty Exam Readiness',
        backTo: 'Sherpath',
        disabledDescription: "This dashboard is only available to Sherpath and Elsevier Adaptive Quizzing users.\n    If you are interested in using Sherpath or Elsevier Adaptive Quizzing for your nursing program contact your administrator or Elsevier Sales Representative"
    },
    HESI_NCLEX_READINESS: {
        description: 'How are my students progressing towards NCLEX readiness?',
        title: 'HESI Readiness for NCLEX',
        disabledDescription: "This dashboard is only available to HESI users. If you are interested in using HESI\n    for your nursing program contact your administrator or Elsevier Sales Representative"
    },
    READINESS_DASHBOARD: {
        description: 'How are my students progressing toward practice readiness in Shadow Health?',
        title: 'Practice Readiness Dashboard',
        backTo: 'Shadow Health',
        disabledDescription: "This dashboard is only available to Shadow Health users. If you are interested in using Shadow Health\n    for your program, please contact your administrator or Elsevier Sales Representative"
    },
    DEAN_PERSONA: {
        description: 'How is my institution performing across key metrics and outcomes?',
        title: 'Program Success Dashboard',
        disabledDescription: "This dashboard provides comprehensive institutional oversight and strategic insights for academic leadership."
    }
};
export var EAB_EVOLVE_PRODUCT_TYPE_KEY = 'elsevier_assessment_builder_ia';
export var EAB_APP_NAME = 'Elsevier Assessment Builder';
export var CS_EVOLVE_PRODUCT_TYPE_KEY = 'clinicalskills_ia';
export var CS_APP_NAME = 'Clinical Skills';
export var CS_APP_TITLE = 'Clinical Skills Performance & Grades Dashboard';
export var HESI_BREADCRUMB_BACK_TITLE = 'HESI Readiness for NCLEX Dashboard';
export var PROGRESS_CHART_PERCENT_POSITION = Object.freeze({
    LEFT: 'LEFT',
    TOP: 'TOP'
});
export var SEARCH_PLACEHOLDER = Object.freeze({
    STUDENT_EXAM_RESULTS: 'Search for a student’s exam results',
    STUDENT_NAME: 'Search by student name',
    EXAM_NAME: 'Search by exam name',
    COURSE: 'Search by course',
    EXAM_GROUPS: 'Search exam groups',
    CHAPTER: 'Search by chapter',
    KEYWORD: 'Search by Keyword',
    CATEGORY: 'Search by Category',
    CATEGORY_NAME: 'Search by category name',
    CAMPUS_NAME: 'Search by campus name'
});
export var VALUE_NA_TEXT = 'n/a';
export var ROUTE_ROLES = {
    INSTRUCTOR: [USER_ROLE.EOLS_INSTRUCTOR, USER_ROLE.EVOLVE_INSTRUCTOR],
    STUDENT: [USER_ROLE.STUDENT],
    ALL: [USER_ROLE.EOLS_INSTRUCTOR, USER_ROLE.EVOLVE_INSTRUCTOR, USER_ROLE.STUDENT]
};
export var APP_ID_VALUE = {
    SHER_EVOL: 'sher_evol',
    SHERPATH: 'sherpath',
    HESI: 'hesi'
};
export var SCORE_SCALE_CONSTANT = Object.freeze({
    MAX_AT_RISK: 750,
    MAX_BELOW_ACCEPTABLE: 850,
    MAX_ACCEPTABLE: 900
});
export var MAX_HESI_SCORE_ON_CHART = 1200;
export var MIN_HESI_SCORE_ON_CHART = 400;
export var LOADING_CONTENT = {
    COURSE_AGGREGATE: 'Loading your Course Data. This may take a moment',
    PERFORMANCE_SUMMARY: 'Loading your upcoming assignments. This may take a moment'
};
export var WELCOME_HEADER = 'Assess, Analyze, Achieve';
export var NOT_FOUND_FALLBACK_MESSAGE = 'Not found';
export var clarityDataIconFeatureFlags = {
    cw: FeatureFlagNames.CW_CLARITY_DATA_ICON_ENABLED,
    ps: FeatureFlagNames.PS_CLARITY_DATA_ICON_ENABLED,
    prd: FeatureFlagNames.PRD_CLARITY_DATA_ICON_ENABLED
};
export var CLARITY_DATA_ICON_FEATURE_BY_DASHBOARD = {
    cw: 'CW_CLARITY_DATA_ICON_ENABLED',
    ps: 'PS_CLARITY_DATA_ICON_ENABLED',
    prd: 'PRD_CLARITY_DATA_ICON_ENABLED',
    ehr: 'EHR_CLARITY_DATA_ICON_ENABLED',
    had: 'HAD_CLARITY_DATA_ICON_ENABLED'
};
export var SESSION_STORAGE_INDEXED_DB_KEY = 'indexedDBStorageName'; // pragma: allowlist secret
export var TIME_NA_VALUE = '-';
export var SHERPATH_COURSE_TYPES = ['EAB', 'EAQ', 'SHERPATH', 'CLASSIC', 'LTICONTENTTOOL'];
export var COMPARISON_CHART_COLOR = {
    RECOMMENDED: {
        backgroundColorClassName: 'u-els-background-color-extended-green-8'
    },
    AT_RISK: {
        backgroundColorClassName: 'u-els-background-color-warn'
    }
};
export var DEMO_EVOLVE_USERNAME = 'skillian26';
export var REFERENCE_DEMO_EVOLVE_USERNAME = 'itesting';
export var SAFE_MED_PRODUCT_TYPE_KEY = 'hesi_safemed_ia';
export var demoUserList = [DEMO_EVOLVE_USERNAME, REFERENCE_DEMO_EVOLVE_USERNAME];
